import {
  faVial,
  faChartLine,
  faFileLines,
  faPrescriptionBottle,
  faPersonWalking,
} from "@fortawesome/pro-regular-svg-icons";
import { Box } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { Typography, Spacer, Arrange, Cell } from "@aviary";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./JourneyOrderSummary.styles";

interface OrderItem {
  text: string;
  icon: any;
}

interface Props {
  journeyPackageId?: string;
}

const JourneyOrderSummary = ({ journeyPackageId: unusedJourneyPackageId }: Props) => {
  const { t } = useTranslation();

  const defaultItems: OrderItem[] = [
    { text: t(l.journeyCheckout.orderSummary.features.labMarkers), icon: faVial },
    { text: t(l.journeyCheckout.orderSummary.features.chartAccess), icon: faChartLine },
    { text: t(l.journeyCheckout.orderSummary.features.detailedInterpretation), icon: faFileLines },
    { text: t(l.journeyCheckout.orderSummary.features.supplementList), icon: faPrescriptionBottle },
    {
      text: t(l.journeyCheckout.orderSummary.features.lifestyleRecommendations),
      icon: faPersonWalking,
    },
  ];

  const renderHeader = () => (
    <div>
      <Cell isFullWidth css={styles.centerText}>
        {t(l.journeyCheckout.orderSummary.journeyWith)}
      </Cell>
      <Spacer height="quarter" />
      <Typography type="h3">{t(l.journeyCheckout.orderSummary.productName)}</Typography>
      <Spacer height="half" />
    </div>
  );

  const renderInterpretationSection = () => (
    <div css={styles.interpretationSection}>
      <Typography type="h5">{t(l.journeyCheckout.orderSummary.interpretationTitle)}</Typography>
      <Spacer height="quarter" />
      <Arrange spacing="xsmall" isVertical>
        {defaultItems.map(renderOrderItem)}
      </Arrange>
    </div>
  );

  const renderOrderItem = (item: OrderItem, index: number) => (
    <Arrange key={index} css={styles.orderItem}>
      <FontAwesomeIcon icon={item.icon} css={styles.itemIcon} />
      <Typography>{item.text}</Typography>
    </Arrange>
  );

  const renderSubtotal = () => (
    <div css={styles.subtotalSection}>
      <Typography type="h3">{t(l.journeyCheckout.orderSummary.subtotal)}</Typography>
      <Typography type="h3">{t(l.journeyCheckout.orderSummary.price)}</Typography>
    </div>
  );

  return (
    <Box backgroundColor="system" padding="small">
      <Typography type="h3">{t(l.journeyCheckout.orderSummary.title)}</Typography>
      <Spacer height="half" />
      <Box padding="small" customCss={styles.summaryContainer}>
        {renderHeader()}
        {renderInterpretationSection()}
      </Box>
      <Spacer height="half" />
      {renderSubtotal()}
    </Box>
  );
};

export { JourneyOrderSummary };
